import { ModeIds, VARIANT_CHESS, VariantTypes } from "@chesshotel/constants";
import { useLeagues } from "../redux/leagues";
import { useStats } from "../redux/stats";

export function useElo() {
  const { leagueScores } = useLeagues();
  const { chess, chess960 } = useStats();
  const elo = chess.elo;
  const elo960 = chess960.elo;

  function getElo(
    leaguePlay: boolean,
    modeId: ModeIds,
    variantId: VariantTypes
  ) {
    if (leaguePlay) {
      return leagueScores[modeId].elo;
    } else {
      return variantId == VARIANT_CHESS ? elo : elo960;
    }
  }

  return getElo;
}
